const ID_TOKEN_KEY = "id_token";
const REFRESH_TOKEN_KEY = "Refresh_token"
export const getToken = () => {
  return window.sessionStorage.getItem(ID_TOKEN_KEY);
};

export const saveToken = token => {
  window.sessionStorage.setItem(ID_TOKEN_KEY, token);
};

export const destroyToken = () => {
  window.sessionStorage.removeItem(ID_TOKEN_KEY);
  destroyRefreshToken();
};

export const getRefreshToken = () => {
  return window.sessionStorage.getItem(REFRESH_TOKEN_KEY);
};

export const saveRefreshToken = token => {
  window.sessionStorage.setItem(REFRESH_TOKEN_KEY, token);
};

export const destroyRefreshToken = () => {
  window.sessionStorage.removeItem(REFRESH_TOKEN_KEY);
};
export default { getToken, saveToken, destroyToken, getRefreshToken, saveRefreshToken, destroyRefreshToken };
